import { createSelector } from 'reselect';

import { getUserRights } from './common.selectors';
import { getAppSettings } from '../../selectors/AppConfigsSelectors';
import { checkTrue } from '../../utils/commonUtils';
import { WFE_OFFLINE_RIGHT } from '../constants/runtime.constants';

export const getIsOfflineSupportAvailable = createSelector(
  [getAppSettings, getUserRights],
  (settings, rights) => {
    const enableOfflineAppSetting = settings['SmartSolve/EnableOfflineSupport'];
    const isOfflineEnabledInAppSettings = checkTrue(enableOfflineAppSetting);
    const hasOfflineRight = rights.includes(WFE_OFFLINE_RIGHT);

    return isOfflineEnabledInAppSettings && hasOfflineRight;
  }
);
